export const BRAND = "BSK Jewellers";
export const BRAND_FULL = "Bhimsen Khanna Chandiwale";
export const TAGLINE = "Timeless jewellery. Personal service. Moments worth remembering.";
export const ADDRESS = "Rani Ka Bagh, Amritsar, Punjab, India";
export const PHONE_DISPLAY = "+91 98727 57572";
export const PHONE_TEL = "+919872757572";
export const WA_NUMBER = "919872757572";
export const EMAIL = "hello@bskjewellers.in"; // placeholder — to be confirmed by BSK
export const HOURS = "Monday – Sunday · 10:30 AM – 8:30 PM"; // placeholder — to be confirmed by BSK
export const INSTAGRAM_URL = "https://www.instagram.com/bskjewellers"; // placeholder handle — to be confirmed
export const FACEBOOK_URL = "https://www.facebook.com/bskjewellers"; // placeholder handle — to be confirmed
export const MAP_EMBED =
    "https://www.google.com/maps?q=BSK%20Jewellers%20Bhimsen%20Khanna%20Chandiwale%20Rani%20Ka%20Bagh%20Amritsar&output=embed";
export const DIRECTIONS_URL =
    "https://www.google.com/maps/dir/?api=1&destination=BSK+Jewellers+Bhimsen+Khanna+Chandiwale+Rani+Ka+Bagh+Amritsar";

export const waLink = (message) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
    general: "Hello BSK Jewellers, I would like to enquire about your jewellery collection.",
    bridal: "Hello BSK Jewellers, I would like to enquire about your bridal jewellery collection.",
    custom: "Hello BSK Jewellers, I would like to discuss a customised jewellery requirement.",
    appointment: "Hello BSK Jewellers, I would like to book a private consultation at your showroom.",
    product: (name) =>
        `Hello BSK Jewellers, I am interested in ${name}. Please share more details and availability.`,
};

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Collections", to: "/collections", mega: true },
    { label: "Bridal", to: "/bridal" },
    { label: "Custom Jewellery", to: "/custom" },
    { label: "About", to: "/about" },
    { label: "Jewellery Guide", to: "/guide" },
    { label: "Visit Us", to: "/visit" },
];

export const MEGA_MENU = [
    {
        title: "Gold",
        links: [
            { label: "Rings", to: "/collections?collection=gold&category=rings" },
            { label: "Earrings", to: "/collections?collection=gold&category=earrings" },
            { label: "Necklaces", to: "/collections?collection=gold&category=necklaces" },
            { label: "Bangles", to: "/collections?collection=gold&category=bangles" },
            { label: "Bracelets", to: "/collections?collection=gold&category=bracelets" },
            { label: "Pendants", to: "/collections?collection=gold&category=pendants" },
        ],
    },
    {
        title: "Diamond",
        links: [
            { label: "Rings", to: "/collections?collection=diamond&category=rings" },
            { label: "Earrings", to: "/collections?collection=diamond&category=earrings" },
            { label: "Necklaces", to: "/collections?collection=diamond&category=necklaces" },
            { label: "Bracelets", to: "/collections?collection=diamond&category=bracelets" },
        ],
    },
    {
        title: "Bridal",
        links: [
            { label: "Bridal Sets", to: "/collections?collection=bridal" },
            { label: "Chokers", to: "/collections?collection=bridal" },
            { label: "Rani Haar", to: "/collections?collection=bridal" },
            { label: "Earrings", to: "/collections?collection=bridal&category=earrings" },
            { label: "Bangles", to: "/collections?collection=bridal&category=bangles" },
            { label: "Maang Tikka", to: "/collections?collection=bridal" },
        ],
    },
    {
        title: "Occasions",
        links: [
            { label: "Engagement", to: "/collections?occasion=engagement" },
            { label: "Wedding", to: "/collections?occasion=wedding" },
            { label: "Festive", to: "/collections?occasion=festive" },
            { label: "Gifting", to: "/collections?occasion=gifting" },
            { label: "Everyday", to: "/collections?occasion=everyday" },
        ],
    },
    {
        title: "Men",
        links: [
            { label: "Rings", to: "/collections?collection=mens&category=rings" },
            { label: "Bracelets", to: "/collections?collection=mens" },
            { label: "Chains", to: "/collections?collection=mens&category=necklaces" },
            { label: "All Men's", to: "/collections?collection=mens" },
        ],
    },
    {
        title: "Bespoke",
        links: [{ label: "Custom Jewellery", to: "/custom" }],
    },
];

export const TRUST_ITEMS = [
    { icon: "Gem", title: "Craftsmanship", note: "Attention to detail in every piece" },
    { icon: "ShieldCheck", title: "Purity & Transparency", note: "Clear, honest information" },
    { icon: "Handshake", title: "Personalised Service", note: "Guidance shaped around you" },
    { icon: "Crown", title: "Premium Selection", note: "Curated for every occasion" },
    { icon: "Compass", title: "Expert Guidance", note: "Advice you can trust" },
];

export const COLLECTION_CARDS = [
    { name: "Gold Jewellery", desc: "Timeless pieces created for elegance and celebration.", image: "/images/ring-macro.jpg", to: "/collections?collection=gold", span: "lg" },
    { name: "Diamond Jewellery", desc: "Sophisticated designs for unforgettable moments.", image: "/images/earrings-pearl.jpg", to: "/collections?collection=diamond", span: "lg" },
    { name: "Bridal Jewellery", desc: "Statement jewellery for the most important celebrations.", image: "/images/royal-bride.jpg", to: "/collections?collection=bridal", span: "md" },
    { name: "Rings", desc: "From everyday elegance to engagement and wedding rings.", image: "/images/ring-gold.jpg", to: "/collections?category=rings", span: "md" },
    { name: "Earrings", desc: "Delicate designs and statement pieces.", image: "/images/earrings-stud.jpg", to: "/collections?category=earrings", span: "sm" },
    { name: "Necklaces", desc: "Traditional and contemporary necklace designs.", image: "/images/pendant.jpg", to: "/collections?category=necklaces", span: "sm" },
    { name: "Bangles & Bracelets", desc: "Classic craftsmanship with modern appeal.", image: "/images/necklace-layered.jpg", to: "/collections?category=bangles", span: "sm" },
    { name: "Pendants", desc: "Elegant pieces for everyday luxury.", image: "/images/ring-box.jpg", to: "/collections?category=pendants", span: "sm" },
    { name: "Men's Jewellery", desc: "Sophisticated designs for the modern gentleman.", image: "/images/flatlay.jpg", to: "/collections?collection=mens", span: "md" },
    { name: "Custom Jewellery", desc: "Jewellery created around your personal vision.", image: "/images/goldsmith-2.jpg", to: "/custom", span: "md" },
];

export const OCCASIONS = [
    { name: "Engagement", line: "For the beginning of forever.", image: "/images/earrings-hoops.jpg", to: "/collections?occasion=engagement" },
    { name: "Wedding", line: "Celebrate the moments that become memories.", image: "/images/bride-indian.jpg", to: "/collections?occasion=wedding" },
    { name: "Bridal", line: "Make your most important day unforgettable.", image: "/images/royal-bride.jpg", to: "/collections?occasion=bridal" },
    { name: "Festive", line: "Add brilliance to every celebration.", image: "/images/fashion-model.jpg", to: "/collections?occasion=festive" },
    { name: "Gifting", line: "Give something that lasts beyond the moment.", image: "/images/hero.jpg", to: "/collections?occasion=gifting" },
    { name: "Everyday Luxury", line: "Because elegance doesn't need an occasion.", image: "/images/necklace-gold.jpg", to: "/collections?occasion=everyday" },
];

export const DIFFERENCE = [
    { icon: "Gem", title: "Craftsmanship", note: "Attention to detail in every piece." },
    { icon: "ShieldCheck", title: "Purity", note: "Clear and transparent jewellery information." },
    { icon: "HeartHandshake", title: "Personalised Experience", note: "Guidance based on individual requirements." },
    { icon: "Sparkles", title: "Curated Collections", note: "A selection designed around different tastes and occasions." },
    { icon: "Users", title: "Customer First", note: "A jewellery experience focused on trust and personal service." },
];

export const BRIDAL_CATEGORIES = [
    "Bridal Sets", "Chokers", "Rani Haar", "Necklace Sets", "Earrings", "Bangles", "Maang Tikka", "Custom Bridal Jewellery",
];

export const INTEREST_OPTIONS = [
    "Bridal Jewellery", "Gold Jewellery", "Diamond Jewellery", "Engagement Ring",
    "Wedding Jewellery", "Custom Jewellery", "Gifting", "Other",
];

export const CATEGORIES = [
    { value: "", label: "All Categories" },
    { value: "gold", label: "Gold", type: "collection" },
    { value: "diamond", label: "Diamond", type: "collection" },
    { value: "bridal", label: "Bridal", type: "collection" },
    { value: "rings", label: "Rings", type: "category" },
    { value: "earrings", label: "Earrings", type: "category" },
    { value: "necklaces", label: "Necklaces", type: "category" },
    { value: "bangles", label: "Bangles", type: "category" },
    { value: "bracelets", label: "Bracelets", type: "category" },
    { value: "pendants", label: "Pendants", type: "category" },
    { value: "mens", label: "Men's", type: "collection" },
];

export const OCCASION_FILTERS = ["wedding", "engagement", "bridal", "festive", "gifting", "everyday"];
export const STYLE_FILTERS = ["traditional", "contemporary", "minimal", "statement"];
export const MATERIAL_FILTERS = ["22K", "18K", "Diamond", "Polki", "Pearl"];

export const FAQS = [
    { q: "What jewellery does BSK Jewellers offer?", a: "We offer a curated selection of gold jewellery, diamond jewellery, bridal sets, rings, earrings, necklaces, bangles, bracelets, pendants and men's jewellery at our showroom in Rani Ka Bagh, Amritsar." },
    { q: "Do you offer bridal jewellery?", a: "Yes. Bridal jewellery is at the heart of BSK Jewellers — bridal sets, chokers, rani haar, earrings, bangles, maang tikka and complete bridal styling guidance. We recommend booking a private bridal consultation." },
    { q: "Do you offer custom jewellery?", a: "Yes, we create customised jewellery around your vision. Share your idea, inspiration or occasion with our experts and we will refine the design together before crafting the final piece." },
    { q: "Do you offer diamond jewellery?", a: "Yes. Our diamond collection includes rings, earrings, necklaces and bracelets. Visit the showroom or enquire on WhatsApp for current designs and availability." },
    { q: "How can I enquire about a product?", a: "Every product page has an 'Enquire on WhatsApp' button that sends us a message with the product name. You can also call us on +91 98727 57572 or visit the showroom." },
    { q: "Can I book a showroom appointment?", a: "Yes. Use the 'Book Appointment' option anywhere on the site, choose your preferred date and time, and we will confirm your private consultation." },
    { q: "Where is BSK Jewellers located?", a: "BSK Jewellers (Bhimsen Khanna Chandiwale) is located in Rani Ka Bagh, Amritsar, Punjab. Use the 'Get Directions' button on our Visit page for turn-by-turn navigation." },
    { q: "What are your showroom timings?", a: "Please call or WhatsApp us on +91 98727 57572 to confirm current showroom timings before your visit." },
    { q: "Do you provide hallmark/certification information?", a: "We believe in complete transparency. Our team will share all purity, hallmarking and certification details applicable to any piece at the showroom or on enquiry." },
    { q: "Do you offer jewellery repair or maintenance?", a: "Please contact us with details of the piece and we will advise on the repair or maintenance services available." },
    { q: "Do you offer exchange/buyback?", a: "Exchange and buyback options may be available on selected pieces. Please speak with our team at the showroom or on WhatsApp for current policy details." },
    { q: "Do you provide delivery?", a: "For high-value jewellery we usually recommend an in-showroom experience. Please contact us to discuss arrangements for your specific purchase." },
    { q: "What payment options are available?", a: "Please contact the showroom for the payment options currently available. Our team will be happy to assist." },
    { q: "Do you serve customers outside Amritsar?", a: "Yes. We welcome customers from across Punjab, and NRI families visiting Punjab. Book a consultation and we will plan your visit around your travel." },
];

export const GUIDES = [
    {
        slug: "understanding-gold-purity",
        title: "Understanding Gold Purity",
        excerpt: "What 'karat' really means, and how purity shapes colour, weight and value.",
        image: "/images/chain-gold.jpg",
        readTime: "4 min",
        sections: [
            { h: "What is a karat?", p: "Gold purity is measured in karats. Pure gold is 24 karat (24K) — 99.9% gold. Jewellery is usually made in 22K (91.6% gold), 18K (75% gold) or 14K, where the remainder is an alloy that adds strength and adjusts colour." },
            { h: "Why purity matters", p: "Higher karat gold has a richer yellow colour and higher intrinsic value, but is softer. Lower karat gold is harder and better suited to stone settings and everyday wear. The right choice depends on how the piece will be worn." },
            { h: "How to check purity", p: "Always look for the BIS hallmark on gold jewellery in India. At BSK Jewellers, our team will walk you through the purity markings on any piece before you buy." },
        ],
    },
    {
        slug: "18k-vs-22k-gold",
        title: "18K vs 22K Gold",
        excerpt: "Two of the most popular choices in India — and how to choose between them.",
        image: "/images/flatlay.jpg",
        readTime: "3 min",
        sections: [
            { h: "22K gold", p: "22K (916) gold is 91.6% pure. It has the deep, warm colour India loves and is the traditional choice for plain gold jewellery — bangles, chains, necklaces and bridal sets." },
            { h: "18K gold", p: "18K (750) gold is 75% pure, alloyed for hardness. It is the international standard for diamond and gemstone jewellery because it holds stones securely and resists scratches better." },
            { h: "Which should you choose?", p: "Choose 22K for heritage gold pieces and investment-minded purchases. Choose 18K for diamond jewellery and designs worn daily. Our experts will help you match the metal to the moment." },
        ],
    },
    {
        slug: "understanding-hallmarking",
        title: "Understanding Hallmarking",
        excerpt: "The BIS hallmark is your assurance of purity. Here's how to read it.",
        image: "/images/goldsmith-2.jpg",
        readTime: "4 min",
        sections: [
            { h: "What is BIS hallmarking?", p: "The Bureau of Indian Standards (BIS) hallmark is a government-backed certification of gold purity. In India, hallmarked jewellery carries the BIS logo, the purity grade (such as 22K916) and a unique HUID identification code." },
            { h: "The HUID code", p: "Every hallmarked piece carries a six-character Hallmark Unique Identification (HUID) number, allowing the piece to be traced and verified." },
            { h: "Why it matters to you", p: "A hallmark protects you at purchase and at exchange. We encourage every customer to ask for and understand hallmarking details — our team will gladly show you on any piece." },
        ],
    },
    {
        slug: "diamond-4cs",
        title: "The Diamond 4Cs",
        excerpt: "Cut, colour, clarity and carat — the four measures of a diamond's beauty.",
        image: "/images/ring-gold.jpg",
        readTime: "5 min",
        sections: [
            { h: "Cut", p: "Cut is the only C shaped by human hands, and it drives a diamond's sparkle. A well-cut stone reflects light internally and returns it to the eye as brilliance." },
            { h: "Colour", p: "White diamonds are graded D (colourless) to Z (visible tint). The finest stones are icy and bright; near-colourless grades offer beautiful value." },
            { h: "Clarity", p: "Clarity measures internal characteristics called inclusions, from Flawless (FL) down to Included (I). Most inclusions are invisible to the naked eye — an 'eye-clean' stone is the sweet spot." },
            { h: "Carat", p: "Carat is weight, not size. Two diamonds of equal carat can look different depending on cut. Our experts will help you balance all four Cs within your budget." },
        ],
    },
    {
        slug: "choose-engagement-ring",
        title: "How to Choose an Engagement Ring",
        excerpt: "A calm, clear approach to the most meaningful purchase you'll make.",
        image: "/images/bridal-set.jpg",
        readTime: "5 min",
        sections: [
            { h: "Start with her style", p: "Notice the jewellery she already wears — minimal or statement, yellow or white metal. Her existing taste is the best brief you can bring to us." },
            { h: "Choose the stone first", p: "For a solitaire, the diamond is the ring. Decide your budget, then balance the 4Cs. A slightly smaller, beautifully cut stone usually outshines a larger, duller one." },
            { h: "Get the size right", p: "Borrow a ring she wears on the correct finger, or ask us for a discreet sizing guide. Resizing is possible, but a perfect fit is a perfect start." },
            { h: "Book a private consultation", p: "At BSK Jewellers you can view solitaires privately, compare stones side by side, and take your time. An engagement ring should never be rushed." },
        ],
    },
    {
        slug: "choose-bridal-jewellery",
        title: "How to Choose Bridal Jewellery",
        excerpt: "Building a bridal look that feels like you — from choker to chooda.",
        image: "/images/bridal-new.jpg",
        readTime: "5 min",
        sections: [
            { h: "Begin with the outfit", p: "Your lehenga or saree sets the palette. Bring photographs — or the fabric itself — to your consultation so metal, stones and styling can be matched perfectly." },
            { h: "Layer with intention", p: "The classic Punjabi bridal stack pairs a choker with a longer rani haar. Keep one the hero; let the other support. Earrings and tikka should echo, not compete." },
            { h: "Think beyond the day", p: "Choose pieces you will wear again — a choker that works with cocktail wear, bangles that restyle for festive occasions. We design bridal sets with a lifetime of moments in mind." },
        ],
    },
    {
        slug: "jewellery-care-guide",
        title: "Jewellery Care Guide",
        excerpt: "Simple habits that keep gold and diamonds brilliant for generations.",
        image: "/images/dark-jewellery.jpg",
        readTime: "4 min",
        sections: [
            { h: "Last on, first off", p: "Perfume, hairspray and cosmetics dull gold and film over diamonds. Put jewellery on after dressing, and remove it before bed, sport or housework." },
            { h: "Gentle cleaning", p: "Soak gold and diamond pieces in warm water with a drop of mild soap, brush softly with a baby toothbrush, rinse and pat dry with a lint-free cloth." },
            { h: "Professional check-ups", p: "Bring fine pieces in once a year. We'll check claws, settings and clasps, and give your jewellery a professional clean." },
        ],
    },
    {
        slug: "store-gold-jewellery",
        title: "How to Store Gold Jewellery",
        excerpt: "The right storage prevents scratches, tangles and tarnish.",
        image: "/images/hero.jpg",
        readTime: "3 min",
        sections: [
            { h: "Separate every piece", p: "Gold is soft and scratches against other jewellery. Store each piece in its own soft pouch or lined compartment." },
            { h: "Control the environment", p: "Keep jewellery in a cool, dry place away from direct sunlight. Silica gel sachets in your jewellery box help absorb moisture." },
            { h: "Chains and necklaces", p: "Fasten clasps before storing and lay chains flat or hang them to prevent knots and kinks." },
        ],
    },
    {
        slug: "ring-size-guide",
        title: "Ring Size Guide",
        excerpt: "Find a comfortable, confident fit — at home or in our showroom.",
        image: "/images/necklace-pendant.jpg",
        readTime: "3 min",
        sections: [
            { h: "Measure at the right time", p: "Fingers change through the day. Measure in the evening when hands are warm, and avoid measuring when cold." },
            { h: "Use an existing ring", p: "Take a ring that fits the intended finger and measure its inner diameter in millimetres. Share the measurement with us and we'll match it to the Indian size scale." },
            { h: "Visit for a perfect fit", p: "The most accurate method is a professional sizing at our showroom — it takes two minutes and is complimentary." },
        ],
    },
    {
        slug: "jewellery-gifting-guide",
        title: "The Jewellery Gifting Guide",
        excerpt: "How to choose a gift that will be worn, loved and remembered.",
        image: "/images/ring-box.jpg",
        readTime: "4 min",
        sections: [
            { h: "Match the moment", p: "Birthdays and milestones call for personal pieces — pendants, studs, delicate bracelets. Weddings and anniversaries deserve statement jewellery with presence." },
            { h: "When in doubt, go classic", p: "Diamond studs, a fine gold chain, or an elegant pendant suit almost everyone and never go out of style." },
            { h: "Let us help", p: "Share the occasion, the person and your budget on WhatsApp, and our team will suggest pieces we know will delight." },
        ],
    },
];

export const INSTAGRAM_IMAGES = [
    "/images/gold-set.jpg", "/images/ring-macro.jpg", "/images/earrings-pearl.jpg",
    "/images/necklace-gold.jpg", "/images/bridal-jewellery.jpg", "/images/fashion-model.jpg",
];
